<template>
  <div class="box-content h-8 w-8 md:h-12 md:w-12"></div>
</template>
